import { render, staticRenderFns } from "./ChartSettings.vue?vue&type=template&id=2e071524&scoped=true"
import script from "./ChartSettings.vue?vue&type=script&lang=js"
export * from "./ChartSettings.vue?vue&type=script&lang=js"
import style0 from "./ChartSettings.vue?vue&type=style&index=0&id=2e071524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e071524",
  null
  
)

export default component.exports